var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10.2056C19.5008 9.59229 19.4479 8.98005 19.3418 8.37562H10.682V11.8418H15.642C15.5405 12.3954 15.3257 12.9231 15.0105 13.3932C14.6953 13.8632 14.2862 14.2658 13.808 14.5767V16.8267H16.7681C18.5014 15.2605 19.5 12.9443 19.5 10.2056Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6819 19C13.1599 19 15.2466 18.2017 16.7681 16.8267L13.808 14.5767C12.9841 15.1242 11.9228 15.4376 10.6819 15.4376C8.28673 15.4376 6.25378 13.8551 5.52682 11.7227H2.47739V14.0414C3.24168 15.5319 4.41364 16.785 5.86242 17.6606C7.3112 18.5362 8.97979 18.9999 10.6819 19Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52682 11.7227C5.1425 10.6052 5.1429 9.39591 5.52722 8.27849V5.95979H2.4778C1.83485 7.2137 1.5 8.59761 1.5 10.001C1.5 11.4043 1.83444 12.7874 2.47739 14.0414L5.52682 11.7227Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6819 4.56302C11.9914 4.54205 13.2568 5.02698 14.2045 5.91299L16.8254 3.34429C15.1635 1.81442 12.9618 0.974492 10.6819 1.00059C8.97979 1.00067 7.3112 1.4644 5.86242 2.34002C4.41364 3.21563 3.24209 4.46922 2.4778 5.95979L5.52722 8.27849C6.25419 6.14603 8.28673 4.56302 10.6819 4.56302Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.eb85b3c27464286f11d160b1ef3ff25a.svg";
export { ForwardRef as ReactComponent };